module.exports = __webpack_public_path__ + "static/icons/icon-map--canada-3fb8d8779ad9dc5fbe82120834ec1e7b.svg";